export default __webpack_public_path__ + "static/media/download-24-px.0ad4d8af.svg";